import { useEffect } from "react";

import { getClient } from "services";
import { getFirebaseAuth } from "services/firebase/auth";
import { getPushType } from "services/firebase/messaging/utils";

import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

export default function useSavePushNotificationToken() {
  const { currentUser } = getFirebaseAuth();
  const isiOSApp = isNativeAppiOS();

  useEffect(() => {
    async function savePushToken(e: CustomEventInit) {
      const token = e.detail;

      if (token && currentUser) {
        const type = getPushType();
        const client = getClient("notificationsService");

        await client.savePushNotificationsToken({ type, token });
      }
    }

    if (isiOSApp) {
      window.addEventListener("push-notification-token", savePushToken);
      return () => {
        window.removeEventListener("push-notification-token", savePushToken);
      };
    }
  }, [currentUser, isiOSApp]);
}
